// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Config$LiveRoom from "../../Config.bs.js";
import * as I18next$LiveRoom from "../bindings/I18next.bs.js";
import * as Vindral$LiveRoom from "../bindings/Vindral.bs.js";
import * as RangeSlider$LiveRoom from "./RangeSlider.bs.js";
import * as CommonStyles$LiveRoom from "../styles/CommonStyles.bs.js";
import * as Utils_Mobile$LiveRoom from "../Utils/Utils_Mobile.bs.js";
import * as SterlingIcons$LiveRoom from "../bindings/SterlingIcons.bs.js";
import * as SterlingTokens$LiveRoom from "../bindings/SterlingTokens.bs.js";
import * as ClientapiQueries$LiveRoom from "../ClientapiQueries.bs.js";
import * as SterlingTypography$LiveRoom from "../bindings/SterlingTypography.bs.js";

function VindralPlayer$Button(props) {
  return React.createElement("button", {
              className: Curry._1(Css.merge, {
                    hd: Curry._1(Css.style, {
                          hd: Css.position("absolute"),
                          tl: {
                            hd: Css.height(Css.px(36)),
                            tl: {
                              hd: Css.width(Css.px(36)),
                              tl: {
                                hd: Css.padding(Css.px(6)),
                                tl: {
                                  hd: Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryWhite_nohashtag)),
                                  tl: {
                                    hd: Css.border(Css.px(1), Css.solid, Css.hex(SterlingTokens$LiveRoom.Colors.primaryWhite_nohashtag)),
                                    tl: {
                                      hd: Css.borderRadius(Css.pct(50)),
                                      tl: {
                                        hd: Css.hover({
                                              hd: Css.cursor("pointer"),
                                              tl: {
                                                hd: Css.borderColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryBlue60_nohashtag)),
                                                tl: /* [] */0
                                              }
                                            }),
                                        tl: /* [] */0
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }),
                    tl: {
                      hd: Belt_Option.getWithDefault(props.className, ""),
                      tl: /* [] */0
                    }
                  }),
              onClick: props.onClick
            }, props.children);
}

var Button = {
  make: VindralPlayer$Button
};

function VindralPlayer$VideoButton(props) {
  return React.createElement(VindralPlayer$Button, {
              onClick: props.onClick,
              className: Curry._1(Css.style, {
                    hd: Css.right(Css.px(0)),
                    tl: /* [] */0
                  }),
              children: React.createElement(SterlingIcons$LiveRoom.Collection.MediaLiveVideoOff24.make, {
                    className: Curry._1(Css.style, {
                          hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryNavy100_nohashtag)),
                          tl: /* [] */0
                        })
                  })
            });
}

var VideoButton = {
  make: VindralPlayer$VideoButton
};

function VindralPlayer$AudioButton(props) {
  var isAudioOn = props.isAudioOn;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  return React.createElement(VindralPlayer$Button, {
              onClick: props.onClick,
              className: Curry._1(Css.style, {
                    hd: Css.right(Css.px(40)),
                    tl: {
                      hd: Css.marginRight(Css.px(8)),
                      tl: {
                        hd: Css.hover({
                              hd: Css.display("flex"),
                              tl: {
                                hd: Css.flexDirection("row"),
                                tl: {
                                  hd: Css.justifyContent("center"),
                                  tl: {
                                    hd: Css.alignItems("center"),
                                    tl: {
                                      hd: isAudioOn ? Css.width(Css.px(70)) : Css.width(Css.px(86)),
                                      tl: {
                                        hd: Css.borderRadius(Css.px(27)),
                                        tl: {
                                          hd: Css.selector("& > p", {
                                                hd: Css.display("flex"),
                                                tl: /* [] */0
                                              }),
                                          tl: /* [] */0
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }),
                        tl: /* [] */0
                      }
                    }
                  }),
              children: null
            }, isAudioOn ? React.createElement(SterlingIcons$LiveRoom.Collection.MediaSoundOn24.make, {
                    className: Curry._1(Css.style, {
                          hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryNavy100_nohashtag)),
                          tl: /* [] */0
                        })
                  }) : React.createElement(SterlingIcons$LiveRoom.Collection.MediaSoundOff24.make, {
                    className: Curry._1(Css.style, {
                          hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryNavy100_nohashtag)),
                          tl: /* [] */0
                        })
                  }), React.createElement(SterlingTypography$LiveRoom.Paragraph12Regular.make, {
                  className: Curry._1(Css.style, {
                        hd: Css.display("none"),
                        tl: {
                          hd: Css.marginLeft(Css.px(8)),
                          tl: {
                            hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryNavy100_nohashtag)),
                            tl: /* [] */0
                          }
                        }
                      }),
                  children: isAudioOn ? Curry._1(t, "Mute") : Curry._1(t, "Unmute")
                }));
}

var AudioButton = {
  make: VindralPlayer$AudioButton
};

function VindralPlayer$CloseVideoButton(props) {
  return React.createElement("button", {
              className: Curry._1(Css.style, {
                    hd: Css.position("absolute"),
                    tl: {
                      hd: Css.display("flex"),
                      tl: {
                        hd: Css.right(Css.px(8)),
                        tl: {
                          hd: Css.top(Css.px(8)),
                          tl: {
                            hd: Css.borderStyle(Css.none),
                            tl: {
                              hd: Css.backgroundColor("transparent"),
                              tl: {
                                hd: Css.outlineStyle(Css.none),
                                tl: {
                                  hd: Css.hover({
                                        hd: Css.cursor("pointer"),
                                        tl: /* [] */0
                                      }),
                                  tl: {
                                    hd: Css.padding(Css.px(8)),
                                    tl: /* [] */0
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }),
              onClick: props.onClick
            }, React.createElement(SterlingIcons$LiveRoom.Collection.CloseRegular24.make, {
                  className: Curry._1(Css.style, {
                        hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryWhite_nohashtag)),
                        tl: /* [] */0
                      })
                }));
}

var CloseVideoButton = {
  make: VindralPlayer$CloseVideoButton
};

var scaleInRight = Curry._1(Css.keyframes, {
      hd: [
        0,
        {
          hd: Css.transform(Css.scale(0.0, 0.0)),
          tl: {
            hd: Css.transformOrigin(Css.pct(100), Css.pct(100)),
            tl: {
              hd: Css.opacity(1.0),
              tl: /* [] */0
            }
          }
        }
      ],
      tl: {
        hd: [
          100,
          {
            hd: Css.transform(Css.scale(1.0, 1.0)),
            tl: {
              hd: Css.transformOrigin(Css.pct(100), Css.pct(100)),
              tl: {
                hd: Css.opacity(1.0),
                tl: /* [] */0
              }
            }
          }
        ],
        tl: /* [] */0
      }
    });

function VindralPlayer(props) {
  var isAudioOn = props.isAudioOn;
  var showStream = props.showStream;
  var pinStream = props.pinStream;
  var onOpen = props.onOpen;
  var onClose = props.onClose;
  var channelId = props.channelId;
  var url = props.url;
  var onClose$1 = onClose !== undefined ? onClose : (function (param) {
        
      });
  var onOpen$1 = onOpen !== undefined ? onOpen : (function (param) {
        
      });
  var isAudioOn$1 = isAudioOn !== undefined ? isAudioOn : true;
  var ref = React.useRef(null);
  var player = React.useRef(undefined);
  var match = React.useReducer((function (state, action) {
          switch (action.TAG | 0) {
            case /* SetVideo */0 :
                return {
                        isVideoOn: action._0,
                        volume: state.volume,
                        hasStartedPlaying: state.hasStartedPlaying,
                        needsUserInput: state.needsUserInput,
                        hasUserInput: state.hasUserInput
                      };
            case /* SetVolume */1 :
                var volume = action._0;
                var player$1 = player.current;
                if (player$1 !== undefined) {
                  player$1.volume = volume;
                }
                return {
                        isVideoOn: state.isVideoOn,
                        volume: volume,
                        hasStartedPlaying: state.hasStartedPlaying,
                        needsUserInput: state.needsUserInput,
                        hasUserInput: state.hasUserInput
                      };
            case /* SetVolumeAndHasUserInput */2 :
                var volume$1 = action._0;
                var player$2 = player.current;
                if (player$2 !== undefined) {
                  player$2.volume = volume$1;
                  Curry._1(player$2.userInput, undefined);
                }
                return {
                        isVideoOn: state.isVideoOn,
                        volume: volume$1,
                        hasStartedPlaying: state.hasStartedPlaying,
                        needsUserInput: state.needsUserInput,
                        hasUserInput: action._1
                      };
            case /* SetHasStartedPlaying */3 :
                return {
                        isVideoOn: state.isVideoOn,
                        volume: state.volume,
                        hasStartedPlaying: action._0,
                        needsUserInput: state.needsUserInput,
                        hasUserInput: state.hasUserInput
                      };
            case /* SetNeedsUserInput */4 :
                var needsUserInput = action._0;
                var match = state.needsUserInput;
                var match$1 = player.current;
                if (!match && match$1 !== undefined) {
                  match$1.volume = 0.0;
                  return {
                          isVideoOn: state.isVideoOn,
                          volume: 0.0,
                          hasStartedPlaying: state.hasStartedPlaying,
                          needsUserInput: needsUserInput,
                          hasUserInput: state.hasUserInput
                        };
                }
                return {
                        isVideoOn: state.isVideoOn,
                        volume: state.volume,
                        hasStartedPlaying: state.hasStartedPlaying,
                        needsUserInput: needsUserInput,
                        hasUserInput: state.hasUserInput
                      };
            
          }
        }), {
        isVideoOn: true,
        volume: 0.5,
        hasStartedPlaying: false,
        needsUserInput: false,
        hasUserInput: false
      });
  var dispatch = match[1];
  var state = match[0];
  var streamTokenQueryRes = Curry.app(ClientapiQueries$LiveRoom.LiveStreamToken.LiveStreamTokenQuery.use, [
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        Curry._3(ClientapiQueries$LiveRoom.LiveStreamToken.LiveStreamTokenQuery.makeVariables, props.auctionId, props.sessionId, undefined)
      ]);
  var streamToken = Belt_Option.map(streamTokenQueryRes.data, (function (param) {
          return param.auctionLiveStreamToken.token;
        }));
  React.useEffect((function () {
          var match = ref.current;
          if (!(match == null) && streamToken !== undefined) {
            var playerInstance = Vindral$LiveRoom.create({
                  url: url,
                  channelId: channelId,
                  authenticationToken: streamToken,
                  minBufferTime: 600,
                  telemetryEnabled: Config$LiveRoom.isProd,
                  container: match
                });
            player.current = playerInstance;
            Curry._1(dispatch, {
                  TAG: /* SetVolume */1,
                  _0: 0.5
                });
            playerInstance.on("playback state", (function (state) {
                    if (state === "playing") {
                      return Curry._1(dispatch, {
                                  TAG: /* SetHasStartedPlaying */3,
                                  _0: true
                                });
                    } else if (state === "paused") {
                      return Curry._1(playerInstance.play, undefined);
                    } else {
                      return ;
                    }
                  }));
            playerInstance.on("needs user input", (function (data) {
                    Curry._1(dispatch, {
                          TAG: /* SetNeedsUserInput */4,
                          _0: data.forAudio
                        });
                  }));
            Curry._1(playerInstance.play, undefined);
          }
          return (function (param) {
                    var playerInstance = player.current;
                    if (playerInstance !== undefined) {
                      Curry._1(playerInstance.unload, undefined);
                      player.current = undefined;
                      return ;
                    }
                    
                  });
        }), [streamToken]);
  React.useEffect((function () {
          if (isAudioOn$1) {
            Curry._1(dispatch, {
                  TAG: /* SetVolume */1,
                  _0: 0.5
                });
          } else {
            Curry._1(dispatch, {
                  TAG: /* SetVolume */1,
                  _0: 0.0
                });
          }
        }), [isAudioOn$1]);
  React.useEffect((function () {
          if (!showStream) {
            Curry._1(dispatch, {
                  TAG: /* SetVideo */0,
                  _0: false
                });
            Curry._1(dispatch, {
                  TAG: /* SetVolume */1,
                  _0: 0
                });
          }
          
        }), [showStream]);
  var toggleFullscreen = (function() {
        let elem = document.querySelector("video");

        if (!document.fullscreenElement && elem) {
          if (elem.requestFullscreen) { // W3C API
            elem.requestFullscreen();
          } else if (elem.mozRequestFullScreen) { // Mozilla API
            elem.mozRequestFullScreen();
          } else if (elem.webkitRequestFullScreen) { // Webkit API
            elem.webkitRequestFullScreen();
          }
        } else {
          document.exitFullscreen();
        }
      });
  var playerContainerStyle = function (isVideoOn, pinStream) {
    return Curry._1(Css.merge, {
                hd: Curry._1(Css.style, {
                      hd: Css.overflow("hidden"),
                      tl: {
                        hd: Css.position("relative"),
                        tl: {
                          hd: Css.zIndex(201),
                          tl: /* [] */0
                        }
                      }
                    }),
                tl: {
                  hd: pinStream ? Curry._1(Css.style, isVideoOn ? ({
                              hd: Css.paddingTop(Css.pct(56.25)),
                              tl: /* [] */0
                            }) : ({
                              hd: Css.paddingTop(Css.px(36)),
                              tl: /* [] */0
                            })) : "",
                  tl: /* [] */0
                }
              });
  };
  var match$1 = state.volume;
  return React.createElement("div", {
              className: playerContainerStyle(showStream || state.isVideoOn, pinStream)
            }, React.createElement("div", {
                  className: pinStream ? Curry._1(Css.style, {
                          hd: Css.width(Css.pct(100)),
                          tl: {
                            hd: Css.height(Css.pct(100)),
                            tl: {
                              hd: Css.position(Css.absolute),
                              tl: {
                                hd: Css.top(Css.px(0)),
                                tl: {
                                  hd: Css.left(Css.px(0)),
                                  tl: /* [] */0
                                }
                              }
                            }
                          }
                        }) : ""
                }, React.createElement("div", {
                      className: Curry._1(Css.style, showStream || state.isVideoOn ? ({
                                hd: Css.display("flex"),
                                tl: {
                                  hd: Css.flexDirection("column"),
                                  tl: {
                                    hd: Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey20_nohashtag)),
                                    tl: {
                                      hd: Css.height("auto"),
                                      tl: {
                                        hd: Css.animationDuration({
                                              NAME: "ms",
                                              VAL: 50
                                            }),
                                        tl: {
                                          hd: Css.animationTimingFunction(Css.easeIn),
                                          tl: {
                                            hd: Css.animationName(scaleInRight),
                                            tl: /* [] */0
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }) : ({
                                hd: Css.display("none"),
                                tl: /* [] */0
                              }))
                    }, React.createElement("div", {
                          ref: Caml_option.some(ref),
                          className: Curry._1(Css.merge, {
                                hd: Curry._1(Css.style, {
                                      hd: Css.width(Css.pct(100)),
                                      tl: {
                                        hd: Css.height(Css.pct(100)),
                                        tl: {
                                          hd: Css.selector("& > video", {
                                                hd: Css.unsafe("objectFit", "cover"),
                                                tl: {
                                                  hd: Css.width(Css.pct(100)),
                                                  tl: {
                                                    hd: Css.height(Css.pct(100)),
                                                    tl: {
                                                      hd: CommonStyles$LiveRoom.mediaV2(/* MobileAndTablet */3, {
                                                            hd: Css.unsafe("objectFit", "contain"),
                                                            tl: {
                                                              hd: Css.maxHeight(Css.px(264)),
                                                              tl: /* [] */0
                                                            }
                                                          }),
                                                      tl: /* [] */0
                                                    }
                                                  }
                                                }
                                              }),
                                          tl: {
                                            hd: Css.selector("& > video::-webkit-media-controls-play-button, & > video::-webkit-media-controls-pause-button", {
                                                  hd: Css.important(Css.display("none")),
                                                  tl: /* [] */0
                                                }),
                                            tl: {
                                              hd: Css.hover({
                                                    hd: Css.selector("& > div", {
                                                          hd: Css.display("flex"),
                                                          tl: {
                                                            hd: Css.animationDuration({
                                                                  NAME: "ms",
                                                                  VAL: 50
                                                                }),
                                                            tl: {
                                                              hd: Css.animationName(Curry._1(Css.keyframes, {
                                                                        hd: [
                                                                          0,
                                                                          {
                                                                            hd: Css.opacity(0),
                                                                            tl: /* [] */0
                                                                          }
                                                                        ],
                                                                        tl: {
                                                                          hd: [
                                                                            100,
                                                                            {
                                                                              hd: Css.opacity(1),
                                                                              tl: /* [] */0
                                                                            }
                                                                          ],
                                                                          tl: /* [] */0
                                                                        }
                                                                      })),
                                                              tl: /* [] */0
                                                            }
                                                          }
                                                        }),
                                                    tl: /* [] */0
                                                  }),
                                              tl: /* [] */0
                                            }
                                          }
                                        }
                                      }
                                    }),
                                tl: /* [] */0
                              }),
                          id: "video-container"
                        }, React.createElement("div", {
                              className: Curry._1(Css.style, {
                                    hd: Css.display("none"),
                                    tl: {
                                      hd: Css.alignItems("center"),
                                      tl: {
                                        hd: Css.justifyContent("spaceBetween"),
                                        tl: {
                                          hd: Css.position("absolute"),
                                          tl: {
                                            hd: Css.bottom(Css.px(10)),
                                            tl: {
                                              hd: Css.left(Css.px(14)),
                                              tl: {
                                                hd: Css.right(Css.px(14)),
                                                tl: {
                                                  hd: Css.zIndex(1),
                                                  tl: {
                                                    hd: Css.backgroundColor(Css.rgba(0, 0, 0, {
                                                              NAME: "num",
                                                              VAL: 0
                                                            })),
                                                    tl: /* [] */0
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  })
                            }, React.createElement("div", {
                                  className: Curry._1(Css.style, {
                                        hd: Css.display("flex"),
                                        tl: {
                                          hd: Css.alignItems("center"),
                                          tl: /* [] */0
                                        }
                                      })
                                }, Utils_Mobile$LiveRoom.isIOS(undefined) && state.hasUserInput ? null : (
                                    match$1 !== 0.0 ? React.createElement(React.Fragment, undefined, React.createElement("button", {
                                                className: Curry._1(Css.style, {
                                                      hd: Css.backgroundColor("transparent"),
                                                      tl: {
                                                        hd: Css.borderStyle("none"),
                                                        tl: {
                                                          hd: Css.outlineStyle("none"),
                                                          tl: {
                                                            hd: Css.cursor("pointer"),
                                                            tl: {
                                                              hd: Css.paddingTop(Css.px(2)),
                                                              tl: {
                                                                hd: Css.paddingBottom(Css.px(0)),
                                                                tl: /* [] */0
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }),
                                                onClick: (function (param) {
                                                    Curry._1(dispatch, {
                                                          TAG: /* SetVolume */1,
                                                          _0: 0
                                                        });
                                                  })
                                              }, React.createElement(SterlingIcons$LiveRoom.Collection.MediaSoundOn24.make, {
                                                    className: Curry._1(Css.style, {
                                                          hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryWhite_nohashtag)),
                                                          tl: /* [] */0
                                                        })
                                                  })), React.createElement(RangeSlider$LiveRoom.make, {
                                                value: state.volume * 100 | 0,
                                                onChange: (function (newValue) {
                                                    var newVolume = newValue / 100;
                                                    Curry._1(dispatch, {
                                                          TAG: /* SetVolume */1,
                                                          _0: newVolume
                                                        });
                                                  })
                                              })) : React.createElement("button", {
                                            className: Curry._1(Css.style, {
                                                  hd: Css.backgroundColor("transparent"),
                                                  tl: {
                                                    hd: Css.borderStyle("none"),
                                                    tl: {
                                                      hd: Css.outlineStyle("none"),
                                                      tl: {
                                                        hd: Css.cursor("pointer"),
                                                        tl: {
                                                          hd: Css.paddingTop(Css.px(2)),
                                                          tl: {
                                                            hd: Css.paddingBottom(Css.px(0)),
                                                            tl: /* [] */0
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }),
                                            onClick: (function (param) {
                                                if (state.needsUserInput && !state.hasUserInput) {
                                                  return Curry._1(dispatch, {
                                                              TAG: /* SetVolumeAndHasUserInput */2,
                                                              _0: 0.5,
                                                              _1: true
                                                            });
                                                } else {
                                                  return Curry._1(dispatch, {
                                                              TAG: /* SetVolume */1,
                                                              _0: 0.5
                                                            });
                                                }
                                              })
                                          }, React.createElement(SterlingIcons$LiveRoom.Collection.MediaSoundOff24.make, {
                                                className: Curry._1(Css.style, {
                                                      hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryWhite_nohashtag)),
                                                      tl: /* [] */0
                                                    })
                                              }))
                                  )), React.createElement("button", {
                                  className: Curry._1(Css.style, {
                                        hd: Css.backgroundColor("transparent"),
                                        tl: {
                                          hd: Css.borderStyle("none"),
                                          tl: {
                                            hd: Css.outlineStyle("none"),
                                            tl: {
                                              hd: Css.cursor("pointer"),
                                              tl: {
                                                hd: Css.paddingTop(Css.px(2)),
                                                tl: {
                                                  hd: Css.paddingBottom(Css.px(0)),
                                                  tl: {
                                                    hd: Css.display("flex"),
                                                    tl: /* [] */0
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }),
                                  onClick: (function (param) {
                                      Curry._1(toggleFullscreen, undefined);
                                    })
                                }, React.createElement(SterlingIcons$LiveRoom.Collection.FullView24.make, {
                                      className: Curry._1(Css.style, {
                                            hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryWhite_nohashtag)),
                                            tl: /* [] */0
                                          })
                                    })))), React.createElement("div", {
                          className: Curry._1(Css.style, {
                                hd: Css.width(Css.pct(100)),
                                tl: /* [] */0
                              })
                        }, React.createElement(VindralPlayer$CloseVideoButton, {
                              onClick: (function (param) {
                                  Curry._1(onClose$1, undefined);
                                  Curry._1(dispatch, {
                                        TAG: /* SetVideo */0,
                                        _0: false
                                      });
                                  Curry._1(dispatch, {
                                        TAG: /* SetVolume */1,
                                        _0: 0
                                      });
                                })
                            }))), showStream || state.isVideoOn ? null : React.createElement(React.Fragment, undefined, Utils_Mobile$LiveRoom.isIOS(undefined) && state.hasUserInput ? null : React.createElement(VindralPlayer$AudioButton, {
                              onClick: (function (param) {
                                  if (state.volume > 0) {
                                    return Curry._1(dispatch, {
                                                TAG: /* SetVolume */1,
                                                _0: 0
                                              });
                                  } else if (state.needsUserInput && !state.hasUserInput) {
                                    return Curry._1(dispatch, {
                                                TAG: /* SetVolumeAndHasUserInput */2,
                                                _0: 0.5,
                                                _1: true
                                              });
                                  } else {
                                    return Curry._1(dispatch, {
                                                TAG: /* SetVolume */1,
                                                _0: 0.5
                                              });
                                  }
                                }),
                              isAudioOn: state.volume > 0
                            }), React.createElement(VindralPlayer$VideoButton, {
                            onClick: (function (param) {
                                Curry._1(onOpen$1, undefined);
                                Curry._1(dispatch, {
                                      TAG: /* SetVideo */0,
                                      _0: true
                                    });
                                Curry._1(dispatch, {
                                      TAG: /* SetVolume */1,
                                      _0: 0.5
                                    });
                              })
                          }))));
}

var make = VindralPlayer;

export {
  Button ,
  VideoButton ,
  AudioButton ,
  CloseVideoButton ,
  scaleInRight ,
  make ,
}
/* scaleInRight Not a pure module */
